<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Google Groups sync list</h3>
        <p class="mt-5">
          In order to receive and send mails from a venue, the venue's Google Group must be added to a sync account. Each sync account can have 98 Google groups (venues) attached.
          
        </p>
      </vs-col>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        search
        :data="syncAccounts"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Sync account</vs-th>
          <vs-th>Venues</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-category">
                  {{ tr.id }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="warning" class="product-order-status">
                  {{ tr.venues.length }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "crm-engage-configuration-email",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Automation lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      syncAccounts: "email/emailSyncList",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("email/getSyncItems");
    this.$vs.loading.close();
  },
};
</script>